// extracted by mini-css-extract-plugin
export default {"container":"author-name_container__3NH6g"};